import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Row, Col, Form, Button } from "react-bootstrap";

export const OnSiteServiceWorksheetSearch = ({ status, handleSearch }) => {
  const [statusValue, setStatusValue] = useState(status ? status : "ALL");

  const onSearch = (e) => {
    e.preventDefault();
    handleSearch({
      status: statusValue === "ALL" ? null : statusValue,
    });
  };

  return (
    <Form onSubmit={onSearch}>
      <Row>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Select
            onChange={(e) => setStatusValue(e.target.value)}
            value={statusValue}
          >
            <option value="ALL">
              <FormattedMessage id="data.onsiteserviceworksheet.data.status.value.ALL" />
            </option>
            <option value="UPLOADED">
              <FormattedMessage id="data.onsiteserviceworksheet.data.status.value.UPLOADED" />
            </option>
            <option value="PROCESSED">
              <FormattedMessage id="data.onsiteserviceworksheet.data.status.value.PROCESSED" />
            </option>
          </Form.Select>
        </Col>
        <Col xs={12} md={2} className="text-md-end">
          <Button type="submit">
            <FormattedMessage id="button.search" />
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

OnSiteServiceWorksheetSearch.propTypes = {
  status: PropTypes.string,
  handleSearch: PropTypes.func.isRequired,
};
